var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-wrap"},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.value)+"%")]),_c('v-progress-linear',{attrs:{"rounded":true,"height":"15","value":_vm.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }